export const CSS = {
  container: "container",
  selected: "selected",
};
